module.exports = __webpack_public_path__ + "img/verbose-1.79312c73.png";